import { differencePolygons, isPointInside, V3toVector3, getPolygonArea } from "@project-rouge/rg-three";
function trimPolyFromThread(poly, threadPoly, desiredPoint) {
  const diffPolys = differencePolygons(poly, [threadPoly]);
  if (!diffPolys.length)
    return [];
  if (desiredPoint) {
    for (const diffPoly of diffPolys) {
      if (!isPointInside(desiredPoint, diffPoly))
        continue;
      return diffPoly.map(V3toVector3);
    }
  }
  let biggestPoly = diffPolys[0];
  let biggestArea = getPolygonArea(biggestPoly);
  for (const diffPoly of diffPolys) {
    const polyArea = getPolygonArea(diffPoly);
    if (polyArea <= biggestArea)
      continue;
    biggestPoly = diffPoly;
    biggestArea = polyArea;
  }
  return biggestPoly.map(V3toVector3);
}
export {
  trimPolyFromThread
};
//# sourceMappingURL=index240.js.map
